export default "__VITE_ASSET__fa232a93__"